/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 4.99988C15 7.20902 16.7909 8.99988 19 8.99988M4 19.9999L4.61997 16.9C4.76122 16.1938 4.83185 15.8406 4.96101 15.5113C5.07566 15.219 5.22432 14.9413 5.40392 14.6837C5.60627 14.3936 5.86092 14.139 6.37023 13.6297L16.0001 3.99986C16.5454 3.45464 16.818 3.18202 17.1121 3.03629C17.6716 2.75899 18.3286 2.759 18.8882 3.03631C19.1823 3.18205 19.4549 3.45467 20.0001 3.99991V3.99991C20.5453 4.54513 20.8179 4.81774 20.9636 5.11182C21.2409 5.67138 21.2409 6.32836 20.9636 6.88792C20.8179 7.18199 20.5453 7.4546 20.0001 7.99982L10.3702 17.6297C9.86091 18.139 9.60626 18.3936 9.31613 18.596C9.05861 18.7756 8.78084 18.9242 8.48856 19.0389C8.15927 19.168 7.80613 19.2387 7.09987 19.3799L4 19.9999Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.0001 9L6.37023 13.6298C5.86092 14.1391 5.60627 14.3937 5.40392 14.6839C5.22432 14.9414 5.07566 15.2192 4.96101 15.5114C4.83185 15.8407 4.76122 16.1939 4.61997 16.9002L4 20L7.09987 19.38C7.80613 19.2388 8.15927 19.1681 8.48856 19.039C8.78084 18.9243 9.05861 18.7757 9.31613 18.5961C9.60626 18.3937 9.86091 18.1391 10.3702 17.6298L15 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M15 5L6.37021 13.6298L6.3702 13.6298C5.86091 14.1391 5.60626 14.3937 5.40392 14.6839C5.22432 14.9414 5.07566 15.2192 4.96101 15.5114C4.83185 15.8407 4.76123 16.1939 4.61997 16.9001L4 20L7.09987 19.38L7.09989 19.38C7.80614 19.2388 8.15927 19.1681 8.48856 19.039C8.78085 18.9243 9.05861 18.7757 9.31613 18.5961C9.60626 18.3937 9.86091 18.1391 10.3702 17.6298L19 9C19 9 17 9 16 8C15 7 15 5 15 5Z"
				fill="currentColor"
			/>
			<path
				d="M15 5C15 7.20914 16.7909 9 19 9M4 20L4.61997 16.9002C4.76122 16.1939 4.83185 15.8407 4.96101 15.5114C5.07566 15.2192 5.22432 14.9414 5.40392 14.6839C5.60627 14.3937 5.86092 14.1391 6.37023 13.6298L16.0001 3.99998C16.5454 3.45476 16.818 3.18215 17.1121 3.03641C17.6716 2.75911 18.3286 2.75912 18.8882 3.03643C19.1823 3.18217 19.4549 3.45479 20.0001 4.00003V4.00003C20.5453 4.54525 20.8179 4.81786 20.9636 5.11194C21.2409 5.67151 21.2409 6.32848 20.9636 6.88804C20.8179 7.18212 20.5453 7.45472 20.0001 7.99994L10.3702 17.6298C9.86091 18.1391 9.60626 18.3937 9.31613 18.5961C9.05861 18.7757 8.78084 18.9243 8.48856 19.039C8.15927 19.1681 7.80613 19.2388 7.09987 19.38L4 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.424 5.51471L5.67919 13.2595C5.16989 13.7688 4.91524 14.0234 4.71289 14.3135C4.53329 14.5711 4.38463 14.8488 4.26998 15.1411C4.14082 15.4704 4.07019 15.8236 3.92894 16.5298L3.32621 19.5435C3.23178 20.0156 3.18457 20.2517 3.25423 20.42C3.31513 20.5672 3.43207 20.6842 3.57928 20.7451C3.74765 20.8147 3.98371 20.7675 4.45584 20.6731L7.46949 20.0704C8.17576 19.9291 8.52889 19.8585 8.85819 19.7293C9.15047 19.6147 9.42824 19.466 9.68576 19.2864C9.97589 19.0841 10.2305 18.8294 10.7398 18.3201L18.4843 10.5757C18.4056 10.5588 18.3286 10.5403 18.2529 10.52C15.9235 9.89589 14.1041 8.07644 13.4799 5.74707C13.4595 5.67101 13.441 5.59368 13.424 5.51471ZM19.8352 9.22477L20.7978 8.26215C21.5898 7.47013 21.9858 7.07412 22.1342 6.61746C22.2647 6.21578 22.2647 5.78309 22.1342 5.38141C21.9859 4.92475 21.5899 4.52874 20.7979 3.7367L20.2627 3.20157C19.4707 2.40952 19.0747 2.01349 18.618 1.86511C18.2164 1.73458 17.7837 1.73458 17.382 1.86509C16.9253 2.01347 16.5293 2.40949 15.7372 3.20153L14.7751 4.16361C14.7984 4.67902 14.8431 5.0391 14.9288 5.35884C15.4143 7.17057 16.8294 8.5857 18.6411 9.07115C18.9606 9.15676 19.3204 9.20146 19.8352 9.22477Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 12L20.0001 7.99994C20.5453 7.45472 20.8179 7.18212 20.9636 6.88804C21.2409 6.32848 21.2409 5.67151 20.9636 5.11194C20.8179 4.81786 20.5453 4.54525 20.0001 4.00003V4.00003C19.4549 3.45479 19.1823 3.18217 18.8882 3.03643C18.3286 2.75912 17.6716 2.75911 17.1121 3.03641C16.818 3.18215 16.5454 3.45476 16.0001 3.99998L6.37023 13.6298C5.86092 14.1391 5.60627 14.3937 5.40392 14.6839C5.22432 14.9414 5.07566 15.2192 4.96101 15.5114C4.83185 15.8407 4.76122 16.1939 4.61997 16.9002L4 20L7.09987 19.38C7.80613 19.2388 8.15927 19.1681 8.48856 19.039C8.78084 18.9243 9.05861 18.7757 9.31613 18.5961C9.60626 18.3937 9.86091 18.1391 10.3702 17.6298L13 15M15 5C15 7.20914 16.7909 9 19 9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 5C15 7.20914 16.7909 9 19 9M4 20L4.61997 16.9002C4.76122 16.1939 4.83185 15.8407 4.96101 15.5114C5.07566 15.2192 5.22432 14.9414 5.40392 14.6839C5.60627 14.3937 5.86092 14.1391 6.37023 13.6298L16.0001 3.99998C16.5454 3.45476 16.818 3.18215 17.1121 3.03641C17.6716 2.75911 18.3286 2.75912 18.8882 3.03643C19.1823 3.18217 19.4549 3.45479 20.0001 4.00003V4.00003C20.5453 4.54525 20.8179 4.81786 20.9636 5.11194C21.2409 5.67151 21.2409 6.32848 20.9636 6.88804C20.8179 7.18212 20.5453 7.45472 20.0001 7.99994L10.3702 17.6298C9.86091 18.1391 9.60626 18.3937 9.31613 18.5961C9.05861 18.7757 8.78084 18.9243 8.48856 19.039C8.15927 19.1681 7.80613 19.2388 7.09987 19.38L4 20Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M13.4242 5.51489L5.67934 13.2596C5.17003 13.7689 4.91538 14.0236 4.71303 14.3137C4.53343 14.5712 4.38477 14.849 4.27013 15.1413C4.14096 15.4706 4.07034 15.8237 3.92908 16.53L3.27928 19.779C3.2006 20.1724 3.16125 20.3691 3.2193 20.5095C3.27005 20.6321 3.36751 20.7296 3.49017 20.7803C3.63048 20.8384 3.8272 20.799 4.22064 20.7203L7.46964 20.0705C8.1759 19.9293 8.52904 19.8587 8.85833 19.7295C9.15061 19.6149 9.42838 19.4662 9.6859 19.2866C9.97603 19.0843 10.2307 18.8296 10.74 18.3203L18.4844 10.5759C18.4058 10.559 18.3288 10.5405 18.253 10.5202C15.9237 9.89607 14.1042 8.07663 13.4801 5.74726C13.4597 5.67119 13.4411 5.59387 13.4242 5.51489Z"
				fill="currentColor"
			/>
			<path
				d="M14.7754 4.16381L15.7375 3.20172C16.5295 2.40968 16.9256 2.01366 17.3822 1.86529C17.7839 1.73478 18.2166 1.73478 18.6183 1.8653C19.075 2.01369 19.471 2.40972 20.263 3.20177L20.7981 3.7369C21.5901 4.52893 21.9861 4.92495 22.1345 5.38161C22.265 5.78329 22.265 6.21598 22.1345 6.61766C21.9861 7.07431 21.5901 7.47032 20.7981 8.26234L19.8354 9.22496C19.3207 9.20166 18.9609 9.15696 18.6414 9.07135C16.8296 8.58589 15.4145 7.17077 14.9291 5.35904C14.8434 5.03929 14.7987 4.67922 14.7754 4.16381Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
